<template>
  <v-dialog
    v-model="value"
    persistent
    content-class="centered-dialog pa-10"
    overlay-opacity="0.75"
    overlay-color="overlay"
  >
    <v-layout
      column
      justify-center
      align-center
    >
      <v-progress-circular
        indeterminate
        color="primary"
        :size="48"
        :width="5"
      ></v-progress-circular>
    </v-layout>
  </v-dialog>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    value: false
  }),

  created () {
    Vue.prototype.$loading = (value) => {
      this.value = value
      // let timeOut
      // if (value) {
      //   timeOut = setTimeout(() => {
      //      this.value = value
      //      // }, 500)
      // } else {
      //   clearTimeout(timeOut)
      //   this.value = false
      // }
    }
  }
}
</script>

<style>
.dialog.centered-dialog,
.v-dialog.centered-dialog {
  box-shadow: none;
  width: auto;
}
</style>
